export default __webpack_public_path__ + "static/media/factura_digital.6d99289d.jpeg";